export enum Reminder {
  NONE = 0,
  AT_TIME_OF_EVENT = 1,
  FIVE_MINUTES_BEFORE = 2,
  THIRTY_MINUTES_BEFORE = 3,
  ONE_HOUR_BEFORE = 4,
  TWO_HOURS_BEFORE = 5,
  TWELVE_HOURS_BEFORE = 6,
  ONE_DAY_BEFORE = 7,
  TWO_DAYS_BEFORE = 8,
}

export const REMINDER_OPTIONS = Object.values(Reminder).filter(
  (v): v is Reminder => typeof v === 'number'
);
